import type { TocHeading } from "../../data/study/grammatica-index";

export type GrammaticaTocProps = {
  /** Mono eyebrow, e.g. "In dit hoofdstuk". */
  label: string;
  topicTitle: string;
  headings: TocHeading[];
};

/**
 * Sticky right-rail table of contents (desktop only). Anchor links scroll to
 * the matching heading id rendered by TopicRenderer. No reading-% progress bar
 * — there is no progress backend (see _DECISIONS.md "no backend" rule).
 */
export function GrammaticaToc({ label, topicTitle, headings }: GrammaticaTocProps) {
  return (
    <nav
      aria-label={label}
      className="sticky top-6 rounded-[var(--radius-lg)] border border-[var(--border)] bg-[var(--panel)] p-5 shadow-[var(--shadow)]"
    >
      <p className="mb-3 font-mono-badge text-[10.5px] uppercase tracking-wider text-[var(--ink-faint)]">
        {label}
      </p>
      <p className="border-l-2 border-[var(--accent)] pl-3 py-1.5 text-[13.5px] font-medium text-[var(--accent)]">
        {topicTitle}
      </p>
      {headings.map((h) => (
        <a
          key={h.id}
          href={`#${h.id}`}
          className="block border-l-2 border-transparent pl-3 py-1.5 text-[13.5px] text-[var(--ink-muted)] transition-colors duration-150 ease-out hover:border-[var(--accent)] hover:text-[var(--accent)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--accent)] focus-visible:outline-offset-2"
        >
          {h.text}
        </a>
      ))}
    </nav>
  );
}
